/*
 * Page-load logo reveal — Osmo "logo reveal loader", stripped to the Willow Press wordmark.
 * https://www.osmo.supply/resource/logo-reveal-loader
 *
 * The WILLOWPRESS wordmark fills in to brand black left-to-right (clip-path) over its faint ghost,
 * then the cream overlay lifts up to reveal the page. GSAP core only — no ScrollTrigger / SplitText.
 * Whether it plays at all is decided by the inline head gate in theme.liquid (once per visitor,
 * motion allowed, not in the theme editor); this script only animates the overlay the gate has
 * already made visible, then removes it and releases scroll. Scroll-lock mirrors the mobile-menu
 * pattern in site-header.liquid. Loaded straight after gsap.min.js so it starts as early as
 * possible — Lenis and ScrollTrigger may not exist yet, so every use of them is guarded (and
 * smooth-scroll.js starts Lenis stopped while the loader is active).
 */
(function () {
  const root = document.documentElement;
  const loader = document.querySelector('[data-page-loader]');
  const main = document.getElementById('MainContent');
  if (!loader) return;

  const finish = (played) => {
    root.classList.remove('wp-loader-active');
    loader.style.display = 'none';
    if (main) main.inert = false;
    document.body.style.overflow = '';
    if (window.lenis) window.lenis.start();

    // Nothing was locked, so nothing to re-measure — smooth-scroll.js does the page's post-font
    // ScrollTrigger.refresh().
    if (!played) return;

    // The overlay + scroll-lock are gone now, but Lenis still holds the scroll limit it
    // measured while locked (overflow:clip can leave it at ~0, which pins the page at the
    // top) and the scroll sections may have refreshed mid-lock. Re-measure on the next frame,
    // after the style changes above have applied, so the page is reliably scrollable.
    requestAnimationFrame(() => {
      if (window.lenis) window.lenis.resize();
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    });
  };

  // Gate said don't play (or GSAP missing) → overlay is already display:none; just clean up.
  // Arrived after the 4s CSS failsafe already revealed the page (slow connection) — don't replay
  // the intro over a page the visitor is already using.
  if (!root.classList.contains('wp-loader-active') || !window.gsap || performance.now() > 3500) return finish();

  // Lock scroll (and keep focus / screen readers out of the page behind) while the intro plays.
  document.body.style.overflow = 'hidden';
  if (main) main.inert = true;
  if (window.lenis) window.lenis.stop();

  const fill = loader.querySelector('[data-loader-fill]');

  const play = () => {
    // JS is alive and animating — cancel the CSS failsafe that would otherwise hide the overlay at 4s.
    loader.style.animation = 'none';
    gsap
      .timeline({
        defaults: { ease: 'power2.inOut' },
        onComplete: () => finish(true),
      })
      .fromTo(fill, { clipPath: 'inset(0% 100% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.1 })
      .to(loader, { yPercent: -100, duration: 1.1, ease: 'power2.inOut' }, '+=0.35');
  };

  // Wait for the wordmark's fonts, but never hold the intro back more than 800ms for them.
  if (document.fonts && document.fonts.ready) {
    const timeout = new Promise((resolve) => setTimeout(resolve, 800));
    Promise.race([document.fonts.ready, timeout]).then(play);
  } else {
    play();
  }
})();
